import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePwaInstall } from '../hooks/usePwaInstall';

export default function InstallPrompt() {
  const { pathname } = useLocation();
  const { canOfferInstall, dismiss, install, hasNativeInstallPrompt, isIos } = usePwaInstall();

  const handleInstall = async () => {
    await install();
  };

  /* Mobiele startpagina heeft eigen install-blok */
  if (pathname === '/mobile') return null;

  if (!canOfferInstall) return null;

  return (
    <div className="v-install-bar" role="status">
      <div className="v-install-bar__text">
        <strong>Ventus installeren</strong>
        <span>
          {hasNativeInstallPrompt
            ? 'Voeg Ventus toe aan je startscherm voor een volledig scherm (app-achtig).'
            : isIos
              ? "Op iPhone: tik op Deel en kies 'Zet op beginscherm'."
              : "Op Android: menu van de browser → 'Toevoegen aan startscherm'."}
        </span>
      </div>
      <div className="v-install-bar__actions">
        {hasNativeInstallPrompt && (
          <button type="button" className="v-btn v-btn--primary v-btn--sm" onClick={handleInstall}>
            Installeren
          </button>
        )}
        <button type="button" className="v-btn v-btn--ghost v-btn--sm" onClick={dismiss}>
          Later
        </button>
      </div>
    </div>
  );
}
